import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

import QueryErrorState from 'components/DesignSystem/QueryErrorState';
import QueryCard from 'components/Meteorology/Shared/QueryCard';
import QueryCardHeader from 'components/Meteorology/Shared/QueryCard/Header';
import QueryCardChips from 'components/Meteorology/Shared/QueryCard/Chips';
import QueryCardChip from 'components/Meteorology/Shared/QueryCard/Chip';
import QueryCardTrigger from 'components/Meteorology/Shared/QueryCard/Trigger';
import useObservedDataControlPanel from 'utils/hooks/meteorology/useObservedDataControlPanel';
import SpatialMaps from './SpatialMaps';
import HeatmapCard from './HeatmapCard';
import ControlPanelSheet from './ControlPanelSheet';

export default function ObservedDataMobile() {
  const [sheetOpen, setSheetOpen] = useState(false);
  const {
    optionsLoading,
    variableLabel,
    viewModeLabel,
    plotAreaLabel,
    periodLabel,
    isHeatmap,
    isConsultedHeatmap,
    obsBase64,
    climatologyBase64,
    anomalyBase64,
    heatmapBase64,
    imagesAreFetching,
    alerts,
    queryTrigger,
  } = useObservedDataControlPanel();

  const queryError = alerts.length > 0 ? alerts[0] : undefined;

  if (optionsLoading) {
    return <div className="text-center py-5"><Spinner /></div>;
  }

  return (
    <div className="observed-data-mobile">
      <QueryCard>
        <QueryCardHeader label="Consulta atual" title={variableLabel}>
          <QueryCardChips>
            <QueryCardChip accent>{viewModeLabel}</QueryCardChip>
            {periodLabel && <QueryCardChip>{periodLabel}</QueryCardChip>}
            {!isHeatmap && plotAreaLabel && <QueryCardChip>{plotAreaLabel}</QueryCardChip>}
          </QueryCardChips>
        </QueryCardHeader>
        <QueryCardTrigger
          onClick={() => setSheetOpen(true)}
          hint="Variável · Área · Período"
        />
      </QueryCard>

      {queryError && (
        <QueryErrorState
          title={queryError.title}
          message={queryError.message}
          onRetry={queryTrigger}
        />
      )}
      {!queryError && isConsultedHeatmap && (
        <HeatmapCard base64={heatmapBase64} fetching={imagesAreFetching} />
      )}
      {!queryError && !isConsultedHeatmap && (
        <SpatialMaps
          observedData={obsBase64}
          climatology={climatologyBase64}
          anomaly={anomalyBase64}
          fetching={imagesAreFetching}
        />
      )}

      <ControlPanelSheet open={sheetOpen} dismiss={() => setSheetOpen(false)} />
    </div>
  );
}
